export enum PermissionType {
  Create = 0x01,
  Read = 0x02,
  Update = 0x04,
  Delete = 0x08,
  All = Create | Read | Update | Delete,
}
